import { handleActions } from 'redux-actions';
import * as types from './types';

const initialState = {
  data: {},
  error: null,
  initialLoad: false,
  loading: false,
};

const getUserNotificationSettingsRequest = (state) => {
  return {
    ...state,
    error: null,
    loading: true,
  };
};
const getUserNotificationSettingsRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    loading: false,
  };
};
const getUserNotificationSettingsRequestSuccess = (state, payload) => {
  return {
    ...state,
    data: payload.data,
    error: null,
    initialLoad: true,
    loading: false,
  };
};

const updateUserNotificationSettingsRequest = (state) => {
  return {
    ...state,
    error: null,
    loading: true,
  };
};
const updateUserNotificationSettingsRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error.message,
    loading: false,
  };
};
const updateUserNotificationSettingsRequestSuccess = (state, payload) => {
  return {
    ...state,
    data: payload.data,
    error: null,
    loading: false,
  };
};

export default handleActions(
  {
    [types.GET_USER_NOTIFICATION_SETTINGS_REQUEST]: getUserNotificationSettingsRequest,
    [types.GET_USER_NOTIFICATION_SETTINGS_REQUEST_FAILURE]: getUserNotificationSettingsRequestFailure,
    [types.GET_USER_NOTIFICATION_SETTINGS_REQUEST_SUCCESS]: getUserNotificationSettingsRequestSuccess,
    [types.UPDATE_USER_NOTIFICATION_SETTINGS_REQUEST]: updateUserNotificationSettingsRequest,
    [types.UPDATE_USER_NOTIFICATION_SETTINGS_REQUEST_FAILURE]: updateUserNotificationSettingsRequestFailure,
    [types.UPDATE_USER_NOTIFICATION_SETTINGS_REQUEST_SUCCESS]: updateUserNotificationSettingsRequestSuccess,
  },
  initialState
);
